import { registerMockAPI } from '~/mocks/mockApis';

import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { PostCollectingRequestParams } from '~/types/delivery-agency.types';

const fetchPostCollectingRequest = async (params: PostCollectingRequestParams) => {
  await axiosInstance.post(API_ENDPOINT.DELIVERY_AGENCY.POST_COLLECTING_REQUEST, params);
};

export const usePostCollectingRequestMutation = () => {
  return useMutation<void, TypeErrorResponseData['error'], PostCollectingRequestParams>({
    mutationFn: fetchPostCollectingRequest,
    meta: { showGlobalErrorToast: false },
  });
};

registerMockAPI<{ data: null } | TypeErrorResponseData>({
  method: 'post',
  endpoint: API_ENDPOINT.DELIVERY_AGENCY.POST_COLLECTING_REQUEST,
  label: '배송 주문 반품 신청·조회/반품 신청 등록',
  scenarios: [
    { name: '등록 성공', response: { data: null } },
    {
      name: '등록 실패 (400)',
      status: 400,
      response: { data: null },
    },
    {
      name: '회수 불가 지역 (60400) — 얼럿',
      status: 400,
      response: { error: { code: 60400, message: '회수 서비스 지역이 아닙니다.\n확인 후 다시 시도해주세요.' } },
    },
  ],
});
